<template>
    <section id="our-story">
        <h2>Our Story</h2>
        <div class="story-content">
            <div class="story-text">
                <p>
                    We met in 2016 at a mutual friend's farm in the KZN midlands. James was immediately intrigued by Angie's unique Australian accent. We became great friends and saw each other at a lot of social gatherings throughout the rest of high school.
                </p>

                <p>
                    After school, our paths went in different directions. Angie headed off to England for a year, while James stayed in South Africa to start university. Despite the distance, we kept in touch through texts and calls, and our friendship grew stronger.
                </p>

                <p>
                    On the 17th of May 2018, we decided to give a long-distance relationship a try. While it definitely had its challenges, we would not change a thing.
                </p>

                <p>
                    At the end of that year, Angie moved back to South Africa and started at the same university as James. Finally we were in the same place! Two years later, we moved into an apartment together and adopted a kitten. <i>Cheerio</i> has been our little furry companion ever since.
                </p>

                <p>
                    We now live in Westville, KZN. We love going for runs, cooking, watching Formula 1, and spending time together with our friends and family. Angie works for a tourism company, and James is a software developer. Speaking of which, James built this wedding website from scratch, which Angie thinks is incredibly impressive!
                </p>

                <p>
                    From meeting at high school to building a life together, it's been quite a journey. We're excited to celebrate with everyone as we start this next chapter.
                </p>
            </div>

            <!-- Image Gallery -->
            <ImageGallery />
        </div>
    </section>
</template>

<script>
import ImageGallery from './ImageGallery.vue';

export default {
    name: "OurStorySection",
    components: {
        ImageGallery
    }
}
</script>

<style scoped>
.story-content {
    margin: 0 auto;
    padding-top: 2rem;
}

.story-text {
    line-height: 1.8;
    font-size: 1.1rem;
    color: #333;
}

.story-text p {
    margin-bottom: 1.5rem;
}

.story-text p:last-child {
    margin-bottom: 0;
}

@media (max-width: 768px) {
    .story-text {
        font-size: 1rem;
        line-height: 1.6;
    }
}
</style>
